export const styles = {
  exitDoorEditCtn: {
    marginBottom: "40px",
  },
  inputCtn: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    width: "423px",
    "& button": {
      marginTop: "15px !important",
    },
    "& > div": {
      marginTop: "5px !important",
    },
  },
  description: {
    marginBottom: "10px",
  },
};
